import {logoquizConfig} from '../constants/FIRESTORE_CONFIG';
import {getTranslation} from "../helpers/get-translation";

export const firebase = require("firebase");
require("firebase/firestore");
require("firebase/functions");

firebase.initializeApp(logoquizConfig);
const firestore = firebase.firestore();
export const functions = firebase.functions();

export const CLOUD_FUNCTION_ROOT_COLLECTION = getTranslation("CLOUD_FUNCTION_ROOT_COLLECTION");
export const CLOUD_FUNCTION_ROOT_DOCUMENT = getTranslation("CLOUD_FUNCTION_ROOT_DOCUMENT");

export const fsVersion = firestore.collection(CLOUD_FUNCTION_ROOT_COLLECTION).doc(CLOUD_FUNCTION_ROOT_DOCUMENT);
export const fsAppConfig = fsVersion.collection("config").doc("appConfig");
export const fsLevelCollection = fsVersion.collection("levels");
export const fsUsersCollection = fsVersion.collection("users");
